var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0838 8.16667H8.91715M13.0838 11.5H8.91715M13.0838 4.83333H8.91715M6.00049 1.5L6.00049 16.5M5.00049 1.5H12.0005C13.4006 1.5 14.1007 1.5 14.6355 1.77248C15.1059 2.01217 15.4883 2.39462 15.728 2.86502C16.0005 3.3998 16.0005 4.09987 16.0005 5.5V12.5C16.0005 13.9001 16.0005 14.6002 15.728 15.135C15.4883 15.6054 15.1059 15.9878 14.6355 16.2275C14.1007 16.5 13.4006 16.5 12.0005 16.5H5.00049C3.60036 16.5 2.90029 16.5 2.36551 16.2275C1.89511 15.9878 1.51266 15.6054 1.27297 15.135C1.00049 14.6002 1.00049 13.9001 1.00049 12.5V5.5C1.00049 4.09987 1.00049 3.3998 1.27297 2.86502C1.51266 2.39462 1.89511 2.01217 2.36551 1.77248C2.90029 1.5 3.60036 1.5 5.00049 1.5Z",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListLayout);
export default __webpack_public_path__ + "static/media/icon-list-layout.897770a6f6178f965cece6edda562ef1.svg";
export { ForwardRef as ReactComponent };